import React, { useEffect, useState, memo } from "react";
import moment from "moment";
import { callApi, validateToken } from "../../../../lib/utils";
import LocationHistoryMap from "./LocationHistoryMap";
import LocationHistoryList from "./LocationHistoryList";
import styles from "./LocationHistory.module.css";

const LocationHistory = () => {
  const [historyList, setHistoryList] = useState([]);
  const [pagination, setPagination] = useState({});
  const [perPage, setPerPage] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const [locationHistory, setLocationHistory] = useState({});
  const [selectedId, setSelectedId] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    validateToken((err) => {
      if (err) {
        window.location = "/logout";
        return;
      }
      setLoading(true);
      callApi(
        `/api/patient/geo-location/alert-history`,
        {
          start: moment(new Date())
            .subtract(6, "days")
            .startOf("day")
            .valueOf(),
          end: moment(new Date()).endOf("day").valueOf(),
          page: currentPage,
          limit: parseInt(perPage),
          patientId: null,
          recordId: null,
        },
        "POST",
      )
        .then((response) => {
          setHistoryList(response?.data?.data?.gpsLocationHistory ?? []);
          setPagination(response?.data?.data?.pagination ?? {});
          setLoading(false);
        })
        .catch((err) => {
          console.log("err: ", err);
          setLoading(false);
        });
    });
  }, [perPage, currentPage]);

  useEffect(() => {
    if (historyList?.length > 0) {
      const first = historyList[0];
      setLocationHistory(first);
      setSelectedId(first.id);
    } else {
      setLocationHistory({});
      setSelectedId(null);
    }
  }, [historyList]);

  const setGeoLocationMap = (data) => {
    if (!data) return;
    setSelectedId(data.id);
    setLocationHistory(data);
  };

  const changePage = (page) => {
    setCurrentPage(page);
  };

  const changePerPage = (value) => {
    setPerPage(value);
    setCurrentPage(1);
  };

  return (
    <div className={styles.locationHistory} data-ui="location-alert-history">
      <div className={styles.content}>
        <LocationHistoryMap
          locationHistory={locationHistory}
          heading="Location Alert History Map"
        />
        <LocationHistoryList
          pagination={pagination}
          changePage={changePage}
          perPage={perPage}
          changePerPage={changePerPage}
          historyList={historyList}
          selectedId={selectedId}
          setGeoLocationMap={setGeoLocationMap}
          heading="Safe Location Alert History"
          loading={loading}
        />
      </div>
    </div>
  );
};

export default memo(LocationHistory);
